import React, { useState, useRef } from 'react';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import apiFetch from '@wordpress/api-fetch';
import FacebookIcon from '@material-ui/icons/Facebook';
import InstagramIcon from '@material-ui/icons/Instagram';
import YouTubeIcon from '@material-ui/icons/YouTube';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import TwitterIcon from '@material-ui/icons/Twitter';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { useMedia } from 'use-media';
import Alert from '../alert/block';
import ServiceGaranti from './service-garanti.png';
import style from './block.module.scss';
import clsx from 'clsx';

function Block({
    siteName,
    logoURL,
    menu,
    customSettings,
    mainMenu = null,
    mainMenuAccordion = false,
    socialsText = null,
    socialsBtnType = 'primary',
    footerForm = null,
    catchPhrase = null,
    theme = null,
}) {
    const isMobile = useMedia({ maxWidth: style.mobileBreakpoint });
    const [formResponse, setFormResponse] = useState('');
    const formSubmit = useRef(null);

    const handleSubmitForm = (e) => {
        e.preventDefault();
        formSubmit.current.setAttribute('disabled', true);
        apiFetch({
            path: 'smartfire/v1/footer_form',
            method: 'POST',
            data: {
                email: new URLSearchParams(new FormData(e.target)).get('email'),
                type: footerForm.type,
            },
        }).then((response) => {
            formSubmit.current.removeAttribute('disabled');
            setFormResponse(response);
        });
    };

    return (
        <div className={style.footer} itemscope itemtype="https://schema.org/Organization">
            <div className={style.footerMain}>
                <div className={style.details}>
                    <img
                        className={style.logo}
                        src={isMobile && customSettings.logoMobile ? customSettings.logoMobile : logoURL}
                        alt={siteName}
                    />
                    <ul itemprop="address" itemscope itemtype="https://schema.org/PostalAddress">
                        {customSettings.streetAddress && (
                            <li itemprop="streetAddress">{customSettings.streetAddress}</li>
                        )}
                        {customSettings.boxNumber && <li itemprop="postOfficeBoxNumber">{customSettings.boxNumber}</li>}
                        {customSettings.postalCode && customSettings.locality && (
                            <li>
                                <span itemprop="postalCode">{customSettings.postalCode}</span>{' '}
                                <span itemprop="addressLocality">{customSettings.locality}</span>
                            </li>
                        )}
                        {customSettings.website && (
                            <li className={style.website}>
                                <a href={'//' + customSettings.website} itemprop="url" target="_blank" rel="noreferrer">
                                    {customSettings.website}
                                </a>
                            </li>
                        )}
                        {customSettings.telephone && (
                            <li className={style.telephone}>
                                <a href={'tel:' + customSettings.telephone} itemprop="telephone">
                                    {customSettings.telephone}
                                </a>
                            </li>
                        )}
                        {customSettings.email && (
                            <li className={style.email}>
                                <a href={'mailto:' + customSettings.email} itemprop="email">
                                    {customSettings.email}
                                </a>
                            </li>
                        )}
                    </ul>
                </div>
                {mainMenu &&
                    (mainMenuAccordion ? (
                        <div className={style.mainMenuWrapper}>
                            {Object.values(mainMenu).map((m, index) => {
                                const hasChildren = Object.values(m.children).length > 0;
                                return (
                                    <div key={index}>
                                        {!isMobile ? (
                                            <>
                                                <p>{m.title}</p>
                                                {hasChildren && (
                                                    <ul
                                                        className={clsx(
                                                            style.mainMenu,
                                                            theme === 'soregies' && style.mainMenuSoregies,
                                                        )}
                                                    >
                                                        {Object.values(m.children).map((m, index) => (
                                                            <li
                                                                key={index}
                                                                className={clsx(
                                                                    style.menuItem,
                                                                    m.classes,
                                                                    m.url === window.location.href && style.active,
                                                                )}
                                                            >
                                                                {m.classes.includes('axeptio-footer-menu') ? (
                                                                    // eslint-disable-next-line jsx-a11y/anchor-is-valid
                                                                    <a
                                                                        // eslint-disable-next-line no-script-url
                                                                        href="javascript:openAxeptioCookies()"
                                                                        title={m.title}
                                                                    >
                                                                        {m.title}
                                                                        {theme !== 'soregies' && <ChevronRightIcon />}
                                                                    </a>
                                                                ) : (
                                                                    <a href={m.url} title={m.title}>
                                                                        {m.title}
                                                                        {theme !== 'soregies' && <ChevronRightIcon />}
                                                                    </a>
                                                                )}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                )}
                                            </>
                                        ) : (
                                            <Accordion className={style.accordionMobile}>
                                                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                                    <p>{m.title}</p>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <ul className={style.mainMenu}>
                                                        {Object.values(m.children).map((m, index) => (
                                                            <li
                                                                key={index}
                                                                className={clsx(
                                                                    style.menuItem,
                                                                    m.classes,
                                                                    m.url === window.location.href && style.active,
                                                                )}
                                                            >
                                                                {m.classes.includes('axeptio-footer-menu') ? (
                                                                    // eslint-disable-next-line jsx-a11y/anchor-is-valid
                                                                    <a
                                                                        // eslint-disable-next-line no-script-url
                                                                        href="javascript:openAxeptioCookies()"
                                                                        title={m.title}
                                                                    >
                                                                        {m.title}
                                                                        {theme !== 'soregies' && <ChevronRightIcon />}
                                                                    </a>
                                                                ) : (
                                                                    <a href={m.url} title={m.title}>
                                                                        {m.title}
                                                                        {theme !== 'soregies' && <ChevronRightIcon />}
                                                                    </a>
                                                                )}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </AccordionDetails>
                                            </Accordion>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    ) : (
                        <>
                            {mainMenu && (
                                <div className={style.mainMenuWrapper}>
                                    <ul className={style.mainMenu}>
                                        {Object.values(mainMenu).map((m, index) => (
                                            <li
                                                key={index}
                                                className={clsx(
                                                    style.menuItem,
                                                    m.classes,
                                                    m.url === window.location.href && style.active,
                                                )}
                                            >
                                                {m.classes.includes('axeptio-footer-menu') ? (
                                                    // eslint-disable-next-line no-script-url, jsx-a11y/anchor-is-valid
                                                    <a href="javascript:openAxeptioCookies()" title={m.title}>
                                                        {m.title}
                                                        <ChevronRightIcon />
                                                    </a>
                                                ) : (
                                                    <a href={m.url} title={m.title}>
                                                        {m.title}
                                                        <ChevronRightIcon />
                                                    </a>
                                                )}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                        </>
                    ))}
                <div className={style.contact}>
                    {footerForm && (
                        <form id="footerForm" onSubmit={handleSubmitForm}>
                            <label for="form_email">
                                {footerForm.type === 'demo'
                                    ? 'Faire une demande de démonstration'
                                    : 'Recevez notre newsletter'}
                            </label>
                            <div>
                                <input type="email" name="email" id="form_email" placeholder="exemple@gmail.com" />
                                <input
                                    type="submit"
                                    value={footerForm.type === 'demo' ? 'Envoyer' : "Je m'inscris"}
                                    class="primary"
                                    ref={formSubmit}
                                />
                            </div>
                        </form>
                    )}
                    {formResponse && (
                        <Alert
                            className={style.alert}
                            type={formResponse.success ? 'success' : 'error'}
                            msg={formResponse.msg}
                        />
                    )}
                    {customSettings.footerWysiwyg && (
                        <div
                            dangerouslySetInnerHTML={{ __html: customSettings.footerWysiwyg }}
                            className={style.footerWysiwyg}
                        />
                    )}
                    <div className={style.socials}>
                        {socialsText && <p dangerouslySetInnerHTML={{ __html: socialsText }} />}
                        <ul>
                            {customSettings.facebookUrl && (
                                <li>
                                    <a
                                        className={clsx(style.socialItem, style[socialsBtnType])}
                                        itemprop="sameAs"
                                        href={customSettings.facebookUrl}
                                        target="_blank"
                                        rel="noreferrer noopener"
                                        title="Facebook"
                                    >
                                        <FacebookIcon />
                                    </a>
                                </li>
                            )}
                            {customSettings.instagramUrl && (
                                <li>
                                    <a
                                        className={clsx(style.socialItem, style[socialsBtnType])}
                                        itemprop="sameAs"
                                        href={customSettings.instagramUrl}
                                        target="_blank"
                                        rel="noreferrer noopener"
                                        title="Instagram"
                                    >
                                        <InstagramIcon />
                                    </a>
                                </li>
                            )}
                            {customSettings.youtubeUrl && (
                                <li>
                                    <a
                                        className={clsx(style.socialItem, style[socialsBtnType])}
                                        itemprop="sameAs"
                                        href={customSettings.youtubeUrl}
                                        target="_blank"
                                        rel="noreferrer noopener"
                                        title="YouTube"
                                    >
                                        <YouTubeIcon />
                                    </a>
                                </li>
                            )}
                            {customSettings.linkedinUrl && (
                                <li>
                                    <a
                                        className={clsx(style.socialItem, style[socialsBtnType])}
                                        itemprop="sameAs"
                                        href={customSettings.linkedinUrl}
                                        target="_blank"
                                        rel="noreferrer noopener"
                                        title="LinkedIn"
                                    >
                                        <LinkedInIcon />
                                    </a>
                                </li>
                            )}
                            {customSettings.twitterUrl && (
                                <li>
                                    <a
                                        className={clsx(style.socialItem, style[socialsBtnType])}
                                        itemprop="sameAs"
                                        href={customSettings.twitterUrl}
                                        target="_blank"
                                        rel="noreferrer noopener"
                                        title="Twitter"
                                    >
                                        <TwitterIcon />
                                    </a>
                                </li>
                            )}
                        </ul>
                    </div>
                    {theme === 'soregies' && (
                        <div className={style.imageFooter}>
                            <img src={ServiceGaranti} alt="Service Garanti FRANCE" />
                        </div>
                    )}
                    {catchPhrase && <p className={style.catchPhrase}>{catchPhrase}</p>}
                </div>
            </div>
            <nav className={style.footerNav}>
                <ul>
                    {menu &&
                        Object.values(menu).map((m, index) => (
                            <li
                                key={index}
                                className={clsx(
                                    style.menuItem,
                                    m.classes,
                                    m.url === window.location.href && style.active,
                                )}
                            >
                                <a href={m.url} title={m.title}>
                                    {m.title}
                                </a>
                            </li>
                        ))}
                </ul>
            </nav>
        </div>
    );
}

export default Block;
